import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { CloseIcon } from '../../ui/Icons/CloseIcon';

import {
  BodyText,
  Button,
} from '../../ui';

/**
 * Represents a short subscription banner message for a pro,
 * rendered within the daily, calendar, and client tabs.
 */
const ShortSubscriptionBanner = ({
  banner,
}) => (
  <div
    className={`pro-subscription-banner ${banner.bannerSource}`}
    style={{ ...banner.style, backgroundColor: banner.background }}
    data-testid="short-subscription-banner"
  >
    {!!banner.icon && (
      <Box paddingRight={8} testID="short-subscription-banner-icon">
        <banner.icon color={banner.iconColor} />
      </Box>
    )}
    <Box flexGrow={1} flexShrink={1} alignItems="flex-start">
      <BodyText
        weight={banner.weight}
        color={banner.foreground}
        appearance={banner.appearance}
        testID="short-subscription-banner-header"
      >
        {banner.header}
      </BodyText>
      {!!banner.link && (
        <Button
          onClick={() => banner.action()}
          appearance="link"
          style={{
            border: 'none',
            height: 'auto',
            lineHeight: '20px',
            margin: 0,
            textTransform: 'none',
          }}
          testID="short-subscription-banner-link"
        >
          <BodyText color={colors.silver} appearance="small" style={{ borderBottom: `solid 1px ${colors.silver}` }}>
            {banner.link}
          </BodyText>
        </Button>
      )}
    </Box>
    {!!banner.cta && (
      <div className="button-container">
        <Button
          onClick={() => banner.action()}
          size="medium"
          testID="short-subscription-banner-cta"
        >
          {banner.cta}
        </Button>
      </div>
    )}
    {!!banner.dismiss && (
      <Button
        appearance="none"
        onClick={() => banner.dismiss()}
        style={{ display: 'flex' }}
        testID="short-subscription-banner-dismiss"
      >
        <CloseIcon width={15} height={15} color={colors.ash} />
      </Button>
    )}
  </div>
);

ShortSubscriptionBanner.propTypes = {
  banner: PropTypes.object.isRequired,
};

export default ShortSubscriptionBanner;
